import generateTypes from '../utils/generateTypes';

export const GET_NOTIFICATION_MESSAGES = generateTypes(
    'GET_NOTIFICATION_MESSAGES'
);
export const RESET_NOTIFICATION_MESSAGES = generateTypes(
    'RESET_NOTIFICATION_MESSAGES'
);
